import permissionsMap from 'utils/permissions/permissionsMap';
import { can } from 'utils/permissions/permissionsChecker';

export const accessLevels = {
	full: 'full',
	read: 'read',
};

export default () => {
	return Object
		.values(permissionsMap)
		.map(({ title, items }) => {
			if (items) {
				return Object.values(items).map((item) => {
					if (
						can(item.create)
						|| can(item.update)
						|| can(item.delete)
					) {
						return {
							typeName: title,
							permissionName: item.title,
							accessLevel: accessLevels.full,
						};
					} else if (can(item.read)) {
						return {
							typeName: title,
							permissionName: item.title,
							accessLevel: accessLevels.read,
						}
					} else {
						return null;
					}
				})
			}
			return null;
		})
		.flat(1)
		.filter(Boolean)
		.filter(({ permissionName }) => permissionName)
		.sort((a, b) => {
			if (a.typeName > b.typeName) {
				return 1;
			} else if (a.typeName < b.typeName) {
				return -1;
			} else if (a.typeName === b.typeName) {
				if (a.permissionName > b.permissionName) {
					return 1;
				}
			}
			return -1;
		});
}
